import { render, staticRenderFns } from "./OrderConfiguration.vue?vue&type=template&id=78798b8a"
import script from "./OrderConfiguration.vue?vue&type=script&lang=js"
export * from "./OrderConfiguration.vue?vue&type=script&lang=js"
import style0 from "./OrderConfiguration.vue?vue&type=style&index=0&id=78798b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports